module.exports = __webpack_public_path__ + "img/mg.adfaf5ae.svg";